import { Flex, FlexProps } from '@chakra-ui/react';
import { type ReactNode } from 'react';

type StatusCardDescriptionProps = FlexProps;

export function StatusCardDescription(
  props: StatusCardDescriptionProps
): ReactNode {
  return (
    <Flex gap="2.5" {...props} textStyle="bodyMedium">
      {props.children}
    </Flex>
  );
}
